import { Video, ExternalLink } from 'lucide-react';
import type { Meeting } from '../types';
import { formatDateTime } from '../lib/format';
import { StatusBadge, EmptyState } from './ui';

export default function MeetingsList({ meetings }: { meetings: Meeting[] }) {
  if (meetings.length === 0) return <EmptyState message="No meetings." />;

  return (
    <div className="grid gap-4">
      {meetings.map((m) => (
        <div key={m.id} className="bg-white p-5 rounded-lg shadow-lg">
          <div className="flex items-start justify-between gap-4 flex-wrap">
            <div className="min-w-0">
              <div className="flex items-center space-x-3 mb-1">
                <h3 className="font-semibold">{m.title}</h3>
                <StatusBadge status={m.status} />
              </div>
              {m.description && <p className="text-sm text-gray-500 mb-1">{m.description}</p>}
              <p className="text-xs text-gray-500">
                {formatDateTime(m.meeting_date)} · {m.duration} min · by {m.created_by_name || '—'}
              </p>
              {m.recording_url && (
                <a
                  href={m.recording_url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center mt-2 px-3 py-1.5 rounded-lg border border-green-200 bg-green-50 text-green-700 text-xs hover:bg-green-100"
                >
                  <ExternalLink className="h-3.5 w-3.5 mr-1.5" /> View Recording
                </a>
              )}
            </div>
            <div className="shrink-0">
              <a
                href={m.meeting_url}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center px-3 py-1.5 rounded-lg bg-primary text-black text-xs hover:bg-primary-dark"
              >
                <Video className="h-3.5 w-3.5 mr-1.5" /> Join
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
